class NwRadioGroup extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const hiddenInput = this.querySelector(`input[id="${this.dataset.id}"]`)
    const radios = Array.from(this.querySelectorAll('input[type="radio"]'))
    const hasChecked = radios.some(radio => radio.checked)
    if (!hasChecked) {
      if (radios && radios.length) radios[0].checked = true
    }

    const setHiddenInputValue = (radio) => {
      hiddenInput.value = radio.value;
      ['input', 'change'].forEach(item => {
        hiddenInput.dispatchEvent(new Event(item), {
          bubbles: true,
          cancelable: true,
        })
      })
    }

    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        setHiddenInputValue(radio)
      })
    })
  }
}

customElements.define('nw-radio-group', NwRadioGroup)

class NwCheckboxGroup extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const hiddenInput = this.querySelector(`input[id="${this.dataset.id}"]`)
    // A checkbox with a value of "others"
    const checkboxOfOthers = this.querySelector('input[type="checkbox"][value="Others"]')
    this.othersChecked = false
    const othersInput = checkboxOfOthers.nextElementSibling.nextElementSibling
    const checkboxes = Array.from(this.querySelectorAll('input[type="checkbox"]')).filter(checkbox => checkbox.value !== 'Others')
    this.checkedList = []

    const setHiddenInputValue = () => {
      if (hiddenInput) {
        hiddenInput.value = this.checkedList.map(item => item.value).join(', ');
        ['input', 'change'].forEach(item => {
          hiddenInput.dispatchEvent(new Event(item), {
            bubbles: true,
            cancelable: true,
          })
        })
      }
    }

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          this.checkedList.push({
            value: checkbox.value,
            name: checkbox.name
          })
        } else {
          this.checkedList.splice(this.checkedList.findIndex(item => item.value === checkbox.value), 1)
        }
        setHiddenInputValue()
      })
    })

    if (checkboxOfOthers) {
      checkboxOfOthers.addEventListener('change', () => {
        this.othersChecked = checkboxOfOthers.checked
        othersInput.setAttribute('type', this.othersChecked ? 'text' : 'hidden')
        if (this.othersChecked) {
          this.checkedList.push({
            value: othersInput.value !== '' ? `${window.theme.strings.form.othersPrefix} ${othersInput.value}` : '',
            name: checkboxOfOthers.name
          })
        } else {
          this.checkedList.splice(this.checkedList.findIndex(item => item.name === checkboxOfOthers.name), 1)
        }
        setHiddenInputValue()
      })

      if (othersInput) {
        othersInput.addEventListener('input', () => {
          const searchIndex = this.checkedList.findIndex(item => item.name === checkboxOfOthers.name)
          if (this.othersChecked) {
            if (searchIndex !== -1) {
              this.checkedList[searchIndex].value = othersInput.value !== '' ? `${window.theme.strings.form.othersPrefix} ${othersInput.value}` : ''
            } else {
              this.checkedList.push({
                value: othersInput.value !== '' ? `${window.theme.strings.form.othersPrefix} ${othersInput.value}` : '',
                name: checkboxOfOthers.name
              })
            }
          } else {
            if (searchIndex !== -1) this.checkedList.splice(searchIndex, 1)
          }
          setHiddenInputValue()
        })
      }
    }
  }
}

customElements.define('nw-checkbox-group', NwCheckboxGroup)

const initProductsSelect = (selector, context = document) => {
  if (!selector || !context) return null

  const container = context.querySelector(selector)
  if (!container) return null

  const $select = $(container).selectize({
    persist: false,
    create: function (input) {
      return {
        title: input,
        url: input,
        sku: window.theme.strings.form.customCreatedOption
      }
    },
    closeAfterSelect: true,
    valueField: "url",
    labelField: "title",
    searchField: ["sku", "title"],
    render: {
      item: function (item, escape) {
        const title = item.title ? `<span class="product-title">${escape(item.title)}</span>` : ''
        // const sku = item.sku ? `<span class="product-sku">${escape(item.sku)}</span>` : '';

        return `<div>${title}</div>`
      },
      option: function (item, escape) {
        const imageUrl = item.variantImage || item.image
        const image = imageUrl ? `<img src="${imageUrl}&width=100" class="product-image">` : ''
        const label = item.title ? `<span class="product-label">${escape(item.title)}</span>` : ''
        const caption = item.sku ? `<span class="product-caption">${escape(item.sku)}</span>` : ''

        return `<div class="px-2 py-1 selectize-product-option${image ? ' has-image' : ''}">${image}${label}${caption}</div>`
      },
    }
  })

  return $select[0].selectize
}

const checkedInputsValidity = (inputs, context = document) => {
  const dataList = Array.isArray(inputs) ? inputs : [inputs]

  const invalidInputs = dataList.map(item => {
    const params = {
      input: item,
      isValid: true
    }

    if (item.classList.contains('selectized')) {
      const id = item.getAttribute('id')
      params.isValid = context.querySelector(`#${id}-selectized`).checkValidity()
    } else {
      params.isValid = item.checkValidity()
    }

    return params
  })

  for (let i = 0; i < invalidInputs.length; i++) {
    const { isValid, input } = invalidInputs[i]

    if (input.parentNode) {
      if (isValid) {
        input.parentNode.classList.remove('is-invalid')
      } else {
        input.parentNode.classList.add('is-invalid')
      }
    }
  }

  return invalidInputs.filter(item => !item.isValid).map(item => item.input)
}

function createProductFetcher() {
  let ongoingRequestPromise = null

  return async function getProductList() {
    if (!ongoingRequestPromise) {
      console.log("No ongoing request. Initiating new API call.")

      ongoingRequestPromise = window.getAllProductsGraphql()
        .then(data => {
          console.log("API call successful. Data received.")

          return data
        })
        .catch(error => {
          console.error("API call failed:", error.message)

          ongoingRequestPromise = null
          throw error
        })
    } else {
      console.log("Ongoing request detected. Waiting for its completion.")
    }

    return ongoingRequestPromise
  }
}

const getSharedProductList = createProductFetcher();

function getCookie(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return '';
}


class NwForm extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.submitButton = this.querySelector('#submitBtn')
    this.form = this.querySelector('form')
    this.requestAQuote = document.querySelector('.request-a-quote-button')
    this.requestAQuoteForm = document.querySelector('.request-a-quote-form')
    this.contactInputs = this.querySelectorAll('[name^="contact["]')

    // Get full_url and gclid
    const fullUrlInput = this.form.querySelector('#full_url');
    const gclidInput = this.form.querySelector('#gclid');

    const gclid = getCookie('nw_gclid') || '';

    if (fullUrlInput) {
      fullUrlInput.value = window.location.href || '';
    }

    if (gclidInput) {
      gclidInput.value = gclid;
    }

    this.contactInputs.forEach(input => {
      if (input.tagName !== 'SELECT') {
        input.addEventListener('input', () => {
          checkedInputsValidity(input, this)
        })
      }
    })

    if (this.submitButton) {
      this.submitButton.addEventListener('click', (event) => {
        this.handleSubmit(event)
      })
    }


    if (this.requestAQuote) {
      this.requestAQuote.addEventListener('click', () => {
        this.handleRequestAQuote()
      })
    }

    const control = initProductsSelect('#desiredProductsToPurchased', this)

    if (!control) return

    control.clearOptions()

    const shopUrl = this.dataset.shopUrl
    if (!shopUrl) return

    getSharedProductList().then(products => {
      const newProducts = (products || []).reduce((acc, item) => {
        const { variants, featuredImage, title, handle, id } = item || {}

        if (!variants || !variants.edges || !variants.edges.length) return acc

        const variantNodes = variants.edges.map(edge => edge.node)

        variantNodes.forEach(variant => {
          const { sku, id: variant_id, price, image } = variant || {}
          const { amount, currencyCode } = price || {}

          acc.push({
            sku,
            variant_id: variant_id.replace('gid://shopify/ProductVariant/', ''),
            title,
            url: `${shopUrl}/products/${handle}?variant=${variant_id}`,
            product_id: id.replace('gid://shopify/Product/', ''),
            handle,
            price: amount || '',
            currencyCode: currencyCode || '',
            image: featuredImage && featuredImage.url ? featuredImage.url : '',
            variantImage: image && image.url ? image.url : ''
          })
        })

        return acc
      }, [])

      // console.log('newProducts===', newProducts);

      newProducts.forEach(product => {
        control.addOption({ ...product })
      })
    }).catch(e => {
      console.error(e)
    })
  }

  disconnectedCallback() {
    if (this.contactInputs) {
      this.contactInputs.forEach(input => {
        input.removeEventListener('input', () => { })
      })
    }

    if (this.submitButton) {
      this.submitButton.removeEventListener('click', (event) => {
        this.handleSubmit(event)
      })
    }

    if (this.requestAQuote) {
      this.requestAQuote.removeEventListener('click', () => {
        this.handleRequestAQuote()
      })
    }
  }

  handleSubmit(event) {
    event.preventDefault()

    const invalidFields = checkedInputsValidity(Array.from(this.contactInputs), this)
    // console.log('invalidFields===', invalidFields);

    if (invalidFields.length) {
      if (invalidFields[0].tagName === 'INPUT') invalidFields[0].focus()
      if (invalidFields[0].parentNode) invalidFields[0].parentNode.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
      return
    }

    // const formData = Object.fromEntries((new FormData(this.form)).entries());
    // console.log('form submitted', formData, Object.keys(formData).length);

    // Add gtag conversion tracking
    const emailInput = this.form.querySelector('input[name="contact[email]"]');
    const email = emailInput ? emailInput.value : '';

    if (typeof window.gtag === 'function') {
      window.gtag('set', 'user_data', {
        "email": email
      });

      window.gtag('event', 'conversion', { 'send_to': 'AW-700802547/UGLZCILJtYgbEPPLlc4C' });
    }

    this.form.submit()
  }

  handleRequestAQuote() {
    if (this.requestAQuoteForm) this.requestAQuoteForm.scrollIntoView()
  }
}

customElements.define('nw-form', NwForm)

class FeaturedCategories extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.enableScroll = null
    this.collectionMap = new Map()

    this.quickOrderWrapper = this.querySelector('.quick-order-wrapper')
    this.quickOrderClose = this.querySelector('.quick-order-modal-close')
    this.quickOrderCancel = this.querySelector('.quick-order-modal-cancel-btn')
    this.quickOrderBtn = this.querySelector('.quick-order-modal-order-btn')
    this.quickOrderForm = this.querySelector('#quick-order-form')
    this.contactInputs = this.quickOrderForm ? this.quickOrderForm.querySelectorAll('[name^="contact["]') : null
    this.inquireBtns = Array.from(this.querySelectorAll('.inquire-button'))

    if (this.inquireBtns && this.inquireBtns.length) {
      this.inquireBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          this.openQuickOrderModal(btn)
        })
      })
    }

    if (this.quickOrderClose) {
      this.quickOrderClose.addEventListener('click', () => {
        this.closeQuickOrderModal()
      })
    }

    if (this.quickOrderCancel) {
      this.quickOrderCancel.addEventListener('click', () => {
        this.closeQuickOrderModal()
      })
    }

    if (this.contactInputs && this.contactInputs.length) {
      this.contactInputs.forEach(input => {
        if (input.tagName !== 'SELECT') {
          input.addEventListener('input', () => {
            checkedInputsValidity(input, this)
          })
        }
      })
    }

    if (this.quickOrderBtn) {
      this.quickOrderBtn.addEventListener('click', (event) => {
        this.handleClickOrderBtn(event)
      })
    }

    this.init()

    const queryString = window.location.search
    const params = new URLSearchParams(queryString)

    const contactPosted = params.get('contact_posted')
    const form_type = params.get('contact[form_type]')

    if (contactPosted || (form_type === 'quick-order')) {
      this.openQuickOrderModal()
    }
  }

  disconnectedCallback() {
    if (this.inquireBtns && this.inquireBtns.length) {
      this.inquireBtns.forEach(btn => {
        btn.removeEventListener('click', () => {
          this.openQuickOrderModal(btn)
        })
      })
    }

    if (this.quickOrderClose) {
      this.quickOrderClose.removeEventListener('click', () => {
        this.closeQuickOrderModal()
      })
    }

    if (this.quickOrderCancel) {
      this.quickOrderCancel.removeEventListener('click', () => {
        this.closeQuickOrderModal()
      })
    }

    if (this.contactInputs && this.contactInputs.length) {
      this.contactInputs.forEach(input => {
        if (input.tagName !== 'SELECT') {
          input.removeEventListener('input', () => {
            checkedInputsValidity(input, this)
          })
        }
      })
    }

    if (this.quickOrderBtn) {
      this.quickOrderBtn.removeEventListener('click', (event) => {
        this.handleClickOrderBtn(event)
      })
    }
  }

  async init() {
    try {
      const products = await getSharedProductList()

      if (products && products.length) {
        products.forEach(node => {
          const { collections, featuredImage, title, id, onlineStoreUrl, variants, availableForSale } = node || {}
          const { edges: collectionEdges } = collections || {}

          const item = {
            availableForSale,
            variants,
            title,
            id,
            url: onlineStoreUrl,
            image: featuredImage && featuredImage.url ? featuredImage.url : ''
          }

          if (collectionEdges && collectionEdges.length) {
            collectionEdges.forEach(collection => {
              const { node: collectionNode } = collection || {}
              const { title: collectionTitle, id: collectionId, onlineStoreUrl: collectionOnlineStoreUrl } = collectionNode || {}

              const newCollectionId = collectionId.replace('gid://shopify/Collection/', '')

              if (this.collectionMap.has(newCollectionId)) {
                this.collectionMap.get(newCollectionId).products.push(item)
              } else {
                this.collectionMap.set(newCollectionId, {
                  title: collectionTitle,
                  url: collectionOnlineStoreUrl,
                  products: [item]
                })
              }
            })
          }
        })
      }

      /* const productHanleList = [];

      const allProducts = Array.from(this.collectionMap.values()).flatMap(item => item.products).reduce((acc, item) => {
        if (productHanleList.includes(item.handle)) {
          return acc
        } else {
          productHanleList.push(item.handle);
          return [...acc, item];
        }
      }, []);

      productHanleList.length = 0 */
    } catch (e) {
      console.error(e)
    }
  }

  openQuickOrderModal(btn) {
    const { dataset } = btn || {}

    if (this.quickOrderWrapper) this.quickOrderWrapper.classList.remove('is-status')

    const { id } = dataset || {}

    if (id) {
      const collection = this.collectionMap.get(id)

      const { products } = collection || {}
      // console.log('products===', products);

      const newProducts = (products || []).reduce((acc, item) => {
        const { handle, title, image, url, variants, availableForSale } = item || {}
        const { edges: variantEdges } = variants || {}

        if (variantEdges && variantEdges.length) {
          variantEdges.forEach(variant => {
            const { node: variantNode } = variant || {}
            const { sku, price, image: variantImage, availableForSale: variantAvailableForSale, id } = variantNode || {}
            const { amount, currencyCode } = price || {}

            acc.push({
              handle,
              title,
              image,
              productUrl: url,
              variantImage: variantImage && variantImage.url ? variantImage.url : '',
              sku,
              price: amount || '',
              currencyCode: currencyCode || '',
              availableForSale,
              variantAvailableForSale,
              url: `${url}?variant=${id.replace('gid://shopify/ProductVariant/', '')}`
            })
          })
        }

        return acc
      }, [])

      const control = initProductsSelect('#quickOrderProduct', this)

      if (!control) return

      control.clearOptions()

      if (!newProducts || !newProducts.length) return

      // console.log('newProducts===', newProducts);

      newProducts.forEach(product => {
        control.addOption({ ...product })
      })
    } else {
      if (this.quickOrderWrapper) this.quickOrderWrapper.classList.add('is-status')

      this.scrollIntoView()
    }

    if (this.quickOrderWrapper) this.quickOrderWrapper.classList.add('active')

    this.enableScroll = window.$utils.disableScroll()
  }

  closeQuickOrderModal() {
    if (this.quickOrderWrapper) this.quickOrderWrapper.classList.remove('active')

    if (this.enableScroll) {
      this.enableScroll()
      this.enableScroll = null
    }
  }

  handleClickOrderBtn(event) {
    event.preventDefault()

    if (this.quickOrderForm) {
      const invalidFields = checkedInputsValidity(Array.from(this.contactInputs), this)
      // console.log('invalidFields===', invalidFields);

      if (invalidFields.length) {
        if (invalidFields[0].tagName === 'INPUT') invalidFields[0].focus()
        if (invalidFields[0].parentNode) invalidFields[0].parentNode.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
        return
      }

      // const formData = Object.fromEntries((new FormData(this.quickOrderForm)).entries());
      // console.log('form submitted', formData, Object.keys(formData).length);
      this.quickOrderForm.submit()
    } else {
      this.closeQuickOrderModal()
    }
  }
}

customElements.define('featured-categories', FeaturedCategories)
